import { CSSProperties, forwardRef, ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { Info } from "lucide-react";
import BlockGutter from "./BlockGutter";
import useIsMobile from "components/hooks/useIsMobile";
import Collapse from "@mui/material/Collapse";
export default forwardRef(
  (
    {
      gutterIcon,
      children,
      sx,
      isLast,
      advisorViewOnly,
      bannerText,
      visibilityCTA,
      hideBottomBanner = false,
    }: {
      gutterIcon: ReactNode;
      children: ReactNode;
      sx?: CSSProperties;
      isLast?: boolean;
      advisorViewOnly?: boolean;
      bannerText?: string;
      visibilityCTA?: ReactNode;
      hideBottomBanner?: boolean;
    },
    ref,
  ) => {
    const isMobile = useIsMobile();
    return (
      <Box
        ref={ref}
        sx={{ display: "flex", gap: isMobile ? "12px" : "16px", ...sx }}
      >
        <BlockGutter icon={gutterIcon} isLast={isLast} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0px",
            width: "100%",
            border: "1px solid #D4D4D4",
            borderRadius: "16px",
            marginBottom: "16px",
            overflow: "hidden",
          }}
        >
          <Box flex={1}>{children}</Box>
          {!hideBottomBanner && (
            <Collapse in={advisorViewOnly || !!visibilityCTA}>
              <Box
                sx={(theme) => ({
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: advisorViewOnly ? "#FAF9FA" : "#FBF2E5F2",
                  padding: "12px 24px",
                  borderTop: `1px solid ${theme.palette.border}`,
                  borderRadius: "0 0 16px 16px",
                })}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  {advisorViewOnly ? null : (
                    <Info color="#9A6518" size={16}></Info>
                  )}
                  <Typography
                    variant="bodySmall"
                    sx={{
                      color: advisorViewOnly ? "text.tertiary" : "#9A6518",
                    }}
                  >
                    {bannerText || "Only you can see this."}
                  </Typography>
                </Box>
                {visibilityCTA}
              </Box>
            </Collapse>
          )}
        </Box>
      </Box>
    );
  },
);
